import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CallState } from '@lcs/shared/api';
import { select, Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { createProviderCallCostUpload } from 'src/app/pages/add-provider-call-costs/state/add-provider-call-costs.actions';
import { getAddProviderCallCostCallState } from 'src/app/pages/add-provider-call-costs/state/add-provider-call-costs.selectors';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ndt-call-costs-dialog',
    styleUrls: ['./call-costs-dialog.component.scss'],
    templateUrl: './call-costs-dialog.component.html',
    standalone: false
})
export class CallCostsDialogComponent {
   callCosts: any;

   columns: string[];

   continue$ = new Subject<void>();

   callState$: Observable<CallState>;

   @Output() continueUpload = new EventEmitter<any>();

   isSystemUser: boolean;

   constructor(
      private dialogRef: MatDialogRef<CallCostsDialogComponent>,
      @Inject(MAT_DIALOG_DATA) private data: any,
      protected store: Store
   ) {
      this.callCosts = data.callCosts.providerCallCostPreview;
      this.columns = ['provider', 'code', 'destination', 'cost'];
   }

   ngOnInit(): void {
      this.callState$ = this.store.pipe(select(getAddProviderCallCostCallState));
   }

   onCloseClick(): void {
      this.dialogRef.close();
   }

   onContinue(): void {
      this.store.dispatch(
         createProviderCallCostUpload({
            providerCallCostPreview: this.data.callCosts.providerCallCostPreview,
            providerCallCost: this.data.callCosts.providerCallCost,
         })
      );
   }
}
